import { actionTypes, UserEntersStreetAddress } from "./Actions";

const userEntersStreetAddress: UserEntersStreetAddress = (
  streetAddress: string
) => ({
  streetAddress,
  type: actionTypes.USER_ENTERS_STREET_ADDRESS
});

export default userEntersStreetAddress;
